export default "__VITE_ASSET__BYmpYGr1__"